import {
  IMPRINT_PAGE_ID,
  PRIVACY_POLICY_PAGE_ID,
  TERMS_OF_SERVICE_PAGE_ID,
} from '@/modules/pages/api/pages'

const titleKeyByPageId = {
  [IMPRINT_PAGE_ID]: 'pages.imprint',
  [PRIVACY_POLICY_PAGE_ID]: 'auth.privacy_policy.title',
  [TERMS_OF_SERVICE_PAGE_ID]: 'auth.tos.title',
}

export function getLegalPageTitleKey(pageId) {
  return titleKeyByPageId[pageId] || null
}

export default {
  methods: {
    getPageDisplayTitle(page, pageId = page?.id) {
      const titleKey = getLegalPageTitleKey(pageId)
      return titleKey ? this.$t(titleKey) : page?.title
    },
  },
}
